
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","viewBox":"0 0 18 20","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.5 19H2.643C1.735 19 1 18.105 1 17V3c0-1.105.735-2 1.643-2H13.32c.908 0 1.643.895 1.643 2v6.5","stroke":"#262626","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M16.5 13L11 18.5M16.5 18.5L11 13","stroke":"#DB2121","stroke-width":"1.25","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"stroke":"#363636","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round","d":"M5.75 5.25h4.5"}}),_c('path',{attrs:{"d":"M7.938 9.676l-.24.53h-3.3l.197-.53h3.343zm-.46 1.027l-.256.537H4.4l.196-.537h2.884zm1.087-2.381l-.348.74a2.41 2.41 0 00-.271-.183 1.674 1.674 0 00-.336-.15 1.3 1.3 0 00-.402-.06 1.12 1.12 0 00-.654.197c-.19.13-.337.327-.445.592-.106.263-.16.597-.16 1.002 0 .404.054.738.16 1.001.108.264.256.46.445.587.189.127.407.191.654.191.145 0 .28-.019.402-.057.123-.038.233-.086.33-.144.1-.058.186-.116.257-.174l.353.74c-.177.155-.382.27-.614.349-.23.078-.473.117-.728.117-.425 0-.8-.104-1.129-.311a2.113 2.113 0 01-.768-.898c-.186-.39-.279-.858-.279-1.402 0-.545.093-1.013.279-1.404a2.11 2.11 0 01.768-.9c.328-.21.704-.316 1.129-.316a2.1 2.1 0 011.357.483z","fill":"#363636"}})])
          )
        }
      }
    